function initSharedLinkModal() {
  const modal = document.getElementById('shared-link-modal');
  const closeBtn = document.getElementById('slModalClose');
  const linkEl = document.getElementById('scp-app-open');

  if (!modal) return;

  const pathSegments = window.location.pathname
    .split('/')
    .filter(Boolean);

  const pagesIndex = pathSegments.indexOf('pages');

  if (pagesIndex === -1 || !pathSegments[pagesIndex + 1]) {
    return;
  }

  const pageHandle = pathSegments[pagesIndex + 1];
  const possibleId = pathSegments[pagesIndex + 2];

  const hasId = Boolean(possibleId);

  if (hasId) {
    if (linkEl) {
      const basePath = pathSegments.slice(0, pagesIndex + 2).join('/');
      linkEl.href = `smartcontrolplus://sscp-share/${possibleId}/`;
    }

    modal.style.display = 'none';
    return;
  }

  if(linkEl) {
    linkEl.href = 'smartcontrolplus://sscp-share//';
  }
  modal.style.display = 'flex';

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      modal.style.display = 'none';
    });
  }
}

document.addEventListener('DOMContentLoaded', initSharedLinkModal);
document.addEventListener('shopify:section:load', initSharedLinkModal);
